import * as type from './type';
export default {
    [type.SET_ORDER_ITEM](state, orderItem) {
        state.orderItem = orderItem;
    },
    [type.SET_TAB_STATUS](state, tabStatus) {
        state.tabStatus = tabStatus;
    },
    [type.SET_EXPRESS_COMPANIES](state, expressCompanies) {
        state.expressCompanies = expressCompanies;
    },
    [type.SET_EXPRESS_COMPANIES](state, expressCompanies) {
        state.expressCompanies = expressCompanies;
    },
    [type.SET_LOGISTIC](state, logisticDetail){
        state.logisticDetail = logisticDetail;
    },
    [type.SET_PICK_STATUS](state, pickStatus){
        state.pickStatus = pickStatus;
    },
    [type.SET_TRADE_TYPE](state, pickupInit){
        state.pickupInit = pickupInit;
    },


}


// WEBPACK FOOTER //
// ./src/store/my-order/mutations.js